export default __webpack_public_path__ + "static/media/value.cf771d6a.png";